import { formatCanvasMigrationStatusLabel } from './formatCanvasMigrationStatusLabel'

export type AdminMigrationUiState = {
  statusLabel: string | null
  showMonitor: boolean
}

/** Derive Admin CRM card migration badge + console visibility from DB status. */
export const getAdminMigrationUiState = (
  status: string | null | undefined
): AdminMigrationUiState => ({
  statusLabel: formatCanvasMigrationStatusLabel(status),
  showMonitor: status === 'in_progress',
})
